export enum Permissions {
  All = 'All',
  ViewBookingCms = 'ViewBookingCms',
  UpdateBookingCms = 'UpdateBookingCms',
  ViewMediaCms = 'ViewMediaCms',
  UpdateMediaCms = 'UpdateMediaCms',
  ViewWidgets = 'ViewWidgets',
  UpdateWidgets = 'UpdateWidgets',
  ViewMediaTransfer = 'ViewMediaTransfer',
  UpdateMediaTransfer = 'UpdateMediaTransfer',
  ViewReachAnalytics = 'ViewReachAnalytics',
  ViewReachReportsAnalytics = 'ViewReachReportsAnalytics',
  ExportReachReportsAnalytics = 'ExportReachReportsAnalytics',
  ViewExposuresAnalytics = 'ViewExposuresAnalytics',
  ViewExposuresReportsAnalytics = 'ViewExposuresReportsAnalytics',
  ExportExposuresReportsAnalytics = 'ExportExposuresReportsAnalytics',
  ViewCampaignSendouts = 'ViewCampaignSendouts',
  UpdateCampaignSendouts = 'UpdateCampaignSendouts',
  ExportCampaignSendouts = 'ExportCampaignSendouts',
  ViewForecastAnalytics = 'ViewForecastAnalytics',
  ViewForecastEventAnalytics = 'ViewForecastEventAnalytics',
  UpdateForecastEventAnalytics = 'UpdateForecastEventAnalytics',
  ViewPeopleCounterInsights = 'ViewPeopleCounterInsights',
  ViewPeopleCounterReportsInsights = 'ViewPeopleCounterReportsInsights',
  ExportPeopleCounterReportsInsights = 'ExportPeopleCounterReportsInsights',
  ViewPoiInsights = 'ViewPoiInsights',
  UpdatePoiInsights = 'UpdatePoiInsights',
  ViewPoiCategoriesInsights = 'ViewPoiCategoriesInsights',
  UpdatePoiCategoriesInsights = 'UpdatePoiCategoriesInsights',
  ViewPoiReportsInsights = 'ViewPoiReportsInsights',
  ExportPoiReportsInsights = 'ExportPoiReportsInsights',
  ViewSmsAdmin = 'ViewSmsAdmin',
  ViewChannelAdmin = 'ViewChannelAdmin',
  UpdateChannelAdmin = 'UpdateChannelAdmin',
  ViewScreensAdmin = 'ViewScreensAdmin',
  UpdateScreensAdmin = 'UpdateScreensAdmin',
  ViewDevicesReportsAdmin = 'ViewDevicesReportsAdmin',
  ExportDevicesReportsAdmin = 'ExportDevicesReportsAdmin',
  ViewClientsAdmin = 'ViewClientsAdmin',
  UpdateClientsAdmin = 'UpdateClientsAdmin',
  ViewContactPersonAdmin = 'ViewContactPersonAdmin',
  UpdateContactPersonAdmin = 'UpdateContactPersonAdmin',
  ViewUserPermissionsAdmin = 'ViewUserPermissionsAdmin',
  UpdateUserPermissionsAdmin = 'UpdateUserPermissionsAdmin',
  ViewUsersAdmin = 'ViewUsersAdmin',
  UpdateUsersAdmin = 'UpdateUsersAdmin',
}
